"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_BRAND = void 0;
const R = __importStar(require("ramda"));
const schema_1 = require("./schema");
const theme_1 = require("./theme");
const labels_1 = require("./labels");
const font_1 = require("./font");
const feedback_1 = require("./feedback");
const project_1 = require("../project");
__exportStar(require("./schema"), exports);
__exportStar(require("./theme"), exports);
__exportStar(require("./labels"), exports);
__exportStar(require("./font"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./feedback"), exports);
__exportStar(require("./constants"), exports);
const pickResponsive = R.pickBy((_data, key) => ['fontSize', 'lineHeight'].includes(String(key)));
const SCHEMA_PROGRESSIVE = R.mapObjIndexed(({ style, font, feedback }) => ({
    style: { [project_1.DeviceMode.desktop]: style },
    font: {
        [project_1.DeviceMode.desktop]: font,
        [project_1.DeviceMode.tablet]: R.mapObjIndexed(pickResponsive, font),
        [project_1.DeviceMode.mobile]: R.mapObjIndexed(pickResponsive, font),
    },
    feedback: { [project_1.DeviceMode.desktop]: feedback },
}), schema_1.SCHEMA);
exports.DEFAULT_BRAND = {
    schema: SCHEMA_PROGRESSIVE,
    theme: theme_1.THEME,
    font: font_1.FONT,
    feedback: feedback_1.FEEDBACK,
    labels: labels_1.BRANDS_LABELS.RU,
};
